import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { usePermission } from "../../context/PermissionContext";
import { restrictToHorizontalAxis } from "@dnd-kit/modifiers";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  arrayMove,
  horizontalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { PointerSensor, useSensor, useSensors } from "@dnd-kit/core";
import { HomeIcon, NegobillIcon } from "../../constants/Icons";
function Menu({
  isSideMenuOpen,
  tabs,
  activeTab,
  onClose,
  onSelect,
  onReorder,
}) {
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const { permission, hasModulePermission, activeStoreModules } =
    usePermission();
  const tabsRef = useRef(null);
  const [hoveredTab, setHoveredTab] = useState(null);
  const removeBackdropStyle = () => {
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) backdrop.removeAttribute("style");
  };
  const TAB_ICONS = {
    "/customer": "bx bx-group",
    "/supplier": "bi bi-truck",
    "/product": "ng ng-ng-product-icon fs-6",
    "/listproduct": "ng ng-ng-product-icon fs-6",
    "/allproduct": "ng ng-ng-product-icon fs-6",

    "/listjobcard": "bx bx-id-card",
    "/listservice": "bx bx-notepad",
    "/purchase": "bx bxs-purchase-tag",
    "/setting":"bx bx-cog",
    "/sale": "ng ng-ng-negobill_icon",
    "/listsale": "ng ng-ng-negobill_icon",
    "/substock": "ng ng-ng-stock-icon",
    "/stockavailable": "ng ng-ng-stock-icon",
    "/liststocktransfer": "ng ng-ng-stock-icon",
    "/stockarrival": "ng ng-ng-stock-icon",
    "/stocktrash": "ng ng-ng-stock-icon",
    "/sales-report": "ng ng-ng-negobill_icon",

    "/stock/report": "bx bx-bar-chart-alt-2",
    "/gstr1-Report": "bx bx-bar-chart-alt-2",
    "/hsn-Repor": "bx bx-bar-chart-alt-2",
    "/product-report": "ng ng-ng-product-icon fs-6",
    "/profitloss-report": "bx bx-bar-chart-alt-2",
    "/listProject": "bi bi-hammer",
    "/stock": "ng ng-ng-stock-icon",
    "/liststock": "ng ng-ng-stock-icon",
    "/listestimation": "bx bx-notepad",
    "/mylist": "bx bx-chevron-right",
    "/expense": "ng ng-ng-expence-icon",
    "/expanse-report": "ng ng-ng-expence-icon",
    "/boxcash": "bx bx-money",
    "/recharge": "bx bx-dollar-circle",
    "/paylater": "bx bx-timer",
    "/voucher": "bx bx-file",
    "/analytics": "bx bx-analyse",
    "/profile": "bx bx-user",
    "/customer-upload": "bx bx-upload",
    "/product-upload": "bx bx-upload",
    "/service-doneby-report": "bx bx-user",
    "/listreturnsale": "bx bx-undo",
    "/returnsale": "bx bx-undo",
    "/ViewProject": "bi bi-hammer",
    "/Proforma": "bi bi-receipt",
    "/listpresale": "bi bi-file-earmark-text",
  };
  const DEFAULT_ICON = "bx bx-file";

  useEffect(() => {
    const el = tabsRef.current;
    if (!el) return;

    const activeTabEl = el.querySelector(".tab-active");

    if (activeTabEl) {
      activeTabEl.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [activeTab, currentPath]);
  function SortableTab({ id, children }) {
    const { setNodeRef, attributes, listeners, transform, transition } =
      useSortable({ id });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
    };

    return (
      <li ref={setNodeRef} style={style} className="nav-item dropdown">
        {children({ attributes, listeners })}
      </li>
    );
  }
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 6, // must move 6px before drag starts
      },
    }),
  );

  return (
    <div>
      <div className="primary-menu">
        <nav
          className={`navbar navbar-expand-lg align-items-center ${isSideMenuOpen ? "z-low" : ""}`}
        >
          <div
            className="offcanvas offcanvas-start"
            tabIndex="-1"
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
          >
            <div className="offcanvas-header border-bottom">
              <div className="d-flex align-items-center">
                <div>
                  <img
                    src="/assets/images/logo-icon.png"
                    className="logo-icon"
                    alt="logo icon"
                  />
                </div>
                <div>
                  <h4 className="logo-text">Negobill</h4>
                </div>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body">
              <ul
                className="navbar-nav tabs-scroll gap-1 justify-content-start flex-grow-1 gap-1"
                ref={tabsRef}
              >
                <li className="nav-item dropdown">
                  <Link
                    className={`nav-link ${currentPath === "/dashboard" ? "active" : "border radius10"}`}
                    to="/dashboard"
                  >
                    <div className="parent-icon">
                      <HomeIcon/>
                    </div>
                    <div className="menu-title d-flex align-items-center">
                      Dashboard
                    </div>
                  </Link>
                </li>
                {(hasModulePermission("SALE") || permission === undefined) && (
                  <li className="nav-item dropdown">
                    <Link
                      className={`nav-link ${currentPath === "/sale" ? "active" : "border radius10"}`}
                      to="/sale"
                    >
                      <div className="parent-icon">
                        <NegobillIcon/>
                      </div>
                      <div className="menu-title d-flex align-items-center">
                        Sales
                      </div>
                    </Link>
                  </li>
                )}
                <DndContext
                  modifiers={[restrictToHorizontalAxis]}
                  collisionDetection={closestCenter}
                  sensors={sensors}
                  onDragEnd={({ active, over }) => {
                    if (over && active.id !== over.id) {
                      onReorder(active.id, over.id);
                    }
                  }}
                >
                  <SortableContext
                    items={tabs.map((t) => t.path)}
                    strategy={horizontalListSortingStrategy}
                  >
                    {tabs.map((tab) => {
                      const isVisible =
                        activeTab === tab.path || hoveredTab === tab.path;
                      return (
                        <SortableTab key={tab.path} id={tab.path}>
                          {({ attributes, listeners }) => (
                            <li
                              className="nav-item dropdown"
                              onMouseEnter={() => setHoveredTab(tab.path)}
                              onMouseLeave={() => setHoveredTab(null)}
                            >
                              <Link
                                to={tab.path}
                                className={`nav-link d-flex align-items-center justify-content-between
          ${activeTab === tab.path ? "tab-active" : "border radius10"}`}
                                onClick={() => {
                                  onSelect(tab.path);
                                  removeBackdropStyle();
                                }}
                                {...attributes}
                                {...listeners}
                              >
                                {" "}
                                {isVisible && (
                                  <button
                                    className="btn-close custom-close-btn me-1"
                                    onPointerDown={(e) => {
                                      e.stopPropagation(); // ⛔ stop drag
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation(); // ⛔ stop navigation
                                      onClose(e, tab.path);
                                    }}
                                  />
                                )}
                                {/* LEFT SIDE */}
                                <div className="d-flex align-items-center">
                                  <div className="parent-icon me-2">
                                    <i
                                      className={
                                        tab.path === "/Proforma" ||
                                        tab.path === "/editproforma"
                                          ? tab.name.includes("Quotation")
                                            ? "bx bx-notepad"
                                            : tab.name.includes("Estimation")
                                              ? "bi bi-calculator"
                                              : "bi bi-receipt"
                                          : TAB_ICONS[tab.path] || DEFAULT_ICON
                                      }
                                    />
                                  </div>
                                  <div className="menu-title">{tab.name}</div>
                                </div>
                                {/* CLOSE BUTTON (NO DRAG, NO NAVIGATION) */}
                              </Link>
                            </li>
                          )}
                        </SortableTab>
                      );
                    })}
                  </SortableContext>
                </DndContext>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default Menu;
